export enum CommodityColumnEnum {
    COMMODITY_DESCRIPTION = 'COMMODITY_DESCRIPTION',
    COMMODITY_HS_CODE = 'COMMODITY_HS_CODE',
    COMMODITY_UNIT_OF_MEASURE = 'COMMODITY_UNIT_OF_MEASURE',
    COMMODITY_WEIGHT = 'COMMODITY_WEIGHT',
    COMMODITY_VALUE = 'COMMODITY_VALUE',
    COMMODITY_COUNTRY = 'COMMODITY_COUNTRY'
}
